import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/people/_list/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/people/settings/employment-types" });
  },
});
